import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertTransactionXPathInput, UpsertTransactionXPathPayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_TRANSACTION_XPATH = gql`
    mutation upsertTransactionXPath($input: UpsertTransactionXPathInput!){
        upsertTransactionXPath(input: $input){
            message
            errors {
                code
                message
            }
            result
            transactionXPath {
                id
            }
        }
    }
`;

export const mutationUpsertTransactionXPath = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: {
        transactionXPathInputData: UpsertTransactionXPathInput
    }
): Promise<UpsertTransactionXPathPayload | undefined> => {
    const { transactionId, xPathJson, id } = args.transactionXPathInputData;
    const { data, errors } = await client.mutate<{ upsertTransactionXPath: UpsertTransactionXPathPayload}>({
        variables: { 
            input: { 
                transactionId, 
                xPathJson, 
                id
            } 
        },
        mutation: MUTATION_UPSERT_TRANSACTION_XPATH
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the save of Transaction Document Search Helper.');
    }
    if (data && data.upsertTransactionXPath) {
        return data.upsertTransactionXPath;
    }

    return undefined;
};